import React from "react";
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/home-banner-image.png";
import Navbar from "./navbar.component";
import { FiArrowRight } from "react-icons/fi";
import AppleLogo from "../Assets/apple.png";
import GooglePlay from "../Assets/google-play.png";
import { navigation_constants } from "../constants/navigation.constants";
import { useNavigate } from "react-router-dom";


const Home = () => {
	const navigate = useNavigate()
	
	return (
		<div className="home-container">
			<Navbar />
			<div className="home-banner-container">
				{/* <div className="home-bannerImage-container">
					<img src={BannerBackground} alt="" />
				</div> */}
				<div className="home-text-section">
					<h1 className="primary-heading">
						A Safe Place to Share and Hide your Secrets
					</h1>
					<p className="primary-text">
						Diary entries are private by default, unless you choose to make them public
					</p>
					<button onClick={()=> navigate(navigation_constants.pages.join_beta)} className="primary-button">Join Closed Beta</button>
					<div style={{height: "10px"}}></div>
					
					<div style={{ display: "flex", flexDirection: "row" }}>
						<button className="secondary-button">
							<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
								Download on Play Store
								<FiArrowRight />
							</div>
						</button>

						<div style={{width: "5px"}}></div>
						<button className="secondary-button">
							<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
								Download on IOS Store
								<div style={{width: "4px"}}></div>
								<img src={AppleLogo} alt="Apple Icon" width={20} height={20} style={{marginBottom: 5}} />
							</div>
							
						</button>
					</div>
				</div>
			
				<div className="home-image-section">
					<img src={BannerImage} alt="" />
				</div>
			</div>
		</div>
	);
};

export default Home;
